export default __webpack_public_path__ + "static/media/dyedyarn.5f00d8e1.svg";